import { List } from '@mui/material';

import { NoFlows } from '../NoFlows';
import { ListHeader } from '../ListHeader';
import { FlowStartingPoint } from '../../../../../../../types';
import { SingleFlow } from '../SingleFlow';

export type SelectFlowContentProps = {
  flows?: FlowStartingPoint[];
};

export const SelectFlowContent = ({ flows }: SelectFlowContentProps) => {
  if (!flows || flows.length === 0) return <NoFlows />;

  return (
    <>
      <ListHeader />
      <List disablePadding dense>
        {flows?.map((flow) => (
          <SingleFlow flow={flow} key={flow.nodeId} />
        ))}
      </List>
    </>
  );
};
